export function normalizeUnit(unit: string): string {
	if (/^[\w#]/.test(unit)) {
		return ` ${unit}`;
	}
	return unit;
}

export function normalizeSearchString(str: string): string {
	return removeAccents(str.toLowerCase());
}

export function removeAccents(str: string): string {
	return str
		.replace(/á/g, "a")
		.replace(/é/g, "e")
		.replace(/í/g, "i")
		.replace(/ó/g, "o")
		.replace(/ö/g, "o")
		.replace(/ő/g, "o")
		.replace(/ú/g, "u")
		.replace(/ü/g, "u")
		.replace(/ű/g, "u");
}

export function mapPathToString(path: (string | number)[] | undefined): string {
	return path === undefined ? "" : path.join("|");
}
